import React, { useRef, useState } from "react";
import { useADSContext } from "../../../../../../../../context/ADSProvider";
import PlaygroundEmpty from "./Component/PlaygroundEmpty";
import styles from "./ADSPlaygroundContent.module.scss";
import ADSImage from "../../../../../../../ADSImage";
import PlaygroundSideActions from "./Component/PlaygroundSideActions";
import { AITools } from "../../../../../../../../constant";
import { useAIToolsContext } from "../../../../../../../../context/AIToolsProvider";
import HighlightAndSwap from "./Component/HighlightAndSwap";
import { useImageEditorContext } from "../../../../../../../../context/ImageEditorProvider";
import ImageEditor from "./Component/ImageEditor";
import FaceSwap from "./Component/FaceSwap";
import FaceCorrection from "./Component/FaceCorrection";
import AvatarConverter from "./Component/AvatarConverter";
import GenerationError from "./Component/GenerationError";
import ImageUploader from "../../../../../../../../../../../../Components/ImageUploader/ImageUploader";
import Trash from "../../../../../../../../../../../../Assets/Icons/trash-purple.svg";
import Document from "../../../../../../../../../../../../Assets/Icons/document-upload.svg";

const ADSPlaygroundContent = () => {
  const { selectedAITools, firstSelectedImage, setFirstSelectedImage } =
    useAIToolsContext();
  const {
    selectedProduct,
    loadingProducts,
    generationError,
    handleSelectProduct,
  } = useADSContext();
  const { isEditingImage } = useImageEditorContext();

  const imagePath =
    selectedProduct.imageEditedUrl || selectedProduct.imageUrl || null;

  const hasNoImageInPlayground = !imagePath && !firstSelectedImage;

  const hideBgColor =
    [AITools.SwapFace, AITools.AvatarConverter].includes(selectedAITools) ||
    generationError;

  const hideSideActions =
    [
      AITools.SwapFace,
      AITools.FaceCorrection,
      AITools.AvatarConverter,
    ].includes(selectedAITools) ||
    generationError ||
    hasNoImageInPlayground;

  const showImageUploader =
    !imagePath &&
    !firstSelectedImage &&
    [
      AITools.RemoveBackground,
      AITools.BlurBackground,
      AITools.HighlightAndSwap,
      AITools.HighlightAndSwap2,
      AITools.HighlightAndRemove,
    ].includes(selectedAITools);

  const isAvatarConverter = [AITools.AvatarConverter].includes(selectedAITools);

  const [inputKey, setInputKey] = useState(Date.now());
  const inputRef = useRef(null);

  const handleDelete = () => {
    // need to consider if current product is selected
    setFirstSelectedImage(null);

    if (selectedProduct?.id) {
      handleSelectProduct(selectedProduct);
    }
  };

  const handleUploadedFile = (event) => {
    setInputKey(Date.now());
    const file = event.target.files[0];
    setFirstSelectedImage(file);

    if (selectedProduct?.id) {
      handleSelectProduct(selectedProduct);
    }
  };

  const handleClickUpload = () => {
    inputRef.current?.click();
  };

  const renderContent = () => {
    if (generationError) {
      return <GenerationError errorType={generationError} />;
    }

    if (isEditingImage) {
      return <ImageEditor />;
    }

    if (showImageUploader) {
      return <ImageUploader onUploadFile={setFirstSelectedImage} />;
    }

    switch (selectedAITools) {
      case AITools.HighlightAndSwap:
      case AITools.HighlightAndSwap2:
      case AITools.HighlightAndRemove: {
        return <HighlightAndSwap imagePath={imagePath} />;
      }

      case AITools.SwapFace: {
        return <FaceSwap />;
      }

      case AITools.FaceCorrection: {
        return <FaceCorrection />;
      }

      case AITools.AvatarConverter: {
        return <AvatarConverter />;
      }

      case AITools.RemoveBackground:
      case AITools.BlurBackground: {
        return (
          <div>
            <input
              key={inputKey}
              ref={inputRef}
              accept="image/*"
              style={{ display: "none" }}
              id="remove-blur-bg-raised-button-file"
              multiple={false}
              type="file"
              onChange={handleUploadedFile}
            />

            <ADSImage
              className={styles.image}
              path={imagePath}
              file={firstSelectedImage}
              skeletonWidth={560}
              skeletonHeight={520}
            />

            <section className={styles.actions}>
              <img alt="" src={Trash} onClick={handleDelete} />
              <img alt="" src={Document} onClick={handleClickUpload} />
            </section>
          </div>
        );
      }

      default: {
        return (
          <ADSImage
            className={styles.image}
            path={imagePath}
            skeletonWidth={560}
            skeletonHeight={520}
          />
        );
      }
    }
  };

  if (
    !selectedProduct.id &&
    !loadingProducts &&
    !selectedAITools &&
    !generationError
  ) {
    return <PlaygroundEmpty />;
  }

  return (
    <section
      className={`${styles.wrapper} ${styles.hideBgColor} ${
        isAvatarConverter ? styles.wideContainer : ""
      }`}
    >
      {renderContent()}
      {!hideSideActions && <PlaygroundSideActions />}
    </section>
  );
};

export default ADSPlaygroundContent;
